
/**
 * Check if a user has the required role
 * @param userRole The user's role
 * @param requiredRole The required role
 * @returns True if the user has the required role
 */
export const checkRoleAccess = (userRole: string, requiredRole: string): boolean => {
  // Define role hierarchy
  const roleHierarchy = ['USER', 'DEALER', 'ADMIN', 'SUPER_ADMIN'];
  
  // Convert roles to uppercase for comparison
  const userRoleUpper = userRole.toUpperCase();
  const requiredRoleUpper = requiredRole.toUpperCase();
  
  // Get indices in hierarchy
  const userRoleIndex = roleHierarchy.indexOf(userRoleUpper);
  const requiredRoleIndex = roleHierarchy.indexOf(requiredRoleUpper);
  
  // Invalid roles return false
  if (userRoleIndex === -1 || requiredRoleIndex === -1) return false;
  
  // User has required role if their role is equal or higher in hierarchy
  return userRoleIndex >= requiredRoleIndex;
};
